var _ellipse, _path, _ellipse2, _ellipse3, _rect, _path2, _ellipse4, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundNotComplies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6781,
    cy: 21.081,
    rx: 20.6781,
    ry: 21.081,
    fill: "#747272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4509 26.9188C11.4509 36.4121 29.3522 38.2701 20.0403 38.2701C10.7284 38.2701 3.17969 30.5743 3.17969 21.081C3.17969 11.5877 10.7284 3.89185 20.0403 3.89185C29.3522 3.89185 11.4509 11.3513 11.4509 26.9188Z",
    fill: "#A3A3A3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.7228,
    cy: 21.4052,
    rx: 5.09,
    ry: 5.18918,
    fill: "#A3A3A3"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.7242,
    cy: 21.4053,
    rx: 3.18125,
    ry: 3.24324,
    fill: "#747272"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.08984,
    y: 43.4595,
    width: 31.8125,
    height: 4.54053,
    rx: 2,
    fill: "#747272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9941 46.0538C37.0089 45.8376 43.2654 44.5619 44.5379 41.189C45.8104 37.816 45.9164 32.216 45.8104 29.8376",
    stroke: "#747272",
    strokeWidth: 3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.8097,
    cy: 29.1892,
    rx: 3.8175,
    ry: 3.89188,
    fill: "#838181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3991 31.0057C47.5142 32.3417 45.7345 32.6934 44.424 31.7913C43.1135 30.8892 45.227 31.1586 46.1119 29.8226C46.9968 28.4865 46.318 26.051 47.6285 26.9532C48.939 27.8553 49.284 29.6697 48.3991 31.0057Z",
    fill: "#747272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.571 27.5617C44.2095 26.6754 45.4169 26.4555 45.9232 26.8355C46.2182 27.057 45.7373 27.5447 45.0987 28.4311C44.4602 29.3174 44.0486 29.9329 43.7532 29.7118C43.3186 29.3863 42.9325 28.448 43.571 27.5617Z",
    fill: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundNotComplies);
export default __webpack_public_path__ + "static/media/round-not-complies.d2eddb4ae3fc3c9c0dfaef971013a22a.svg";
export { ForwardRef as ReactComponent };